import { render, staticRenderFns } from "./Odonto.vue?vue&type=template&id=4be24de6"
import script from "./Odonto.vue?vue&type=script&lang=js"
export * from "./Odonto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports